import { SupportHelp } from './components/support/Support'
import { lazy, Suspense } from 'react'
import { useAuth } from './contexts/AuthContext'
import { LogOut } from 'lucide-react'
import { useLocation } from 'react-router-dom'

// Only load what we need for PWA
const PWAHome = lazy(() => import('./pages/PWAHome'))
const Login = lazy(() => import('./pages/Login'))
const WasntMe = lazy(() => import('./pages/auth/WasntMe'))
const Confirm = lazy(() => import('./pages/auth/Confirm'))
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'))

export default function PWAApp() {
  const { isAuthenticated, signOut } = useAuth()
  const location = useLocation()

  const handleLogin = async () => {
    // Login handled by AuthContext
  }

  const handleLogout = async () => {
    await signOut()
  }

  // Loading spinner
  const LoadingSpinner = () => (
    <div className="min-h-screen bg-theme-primary flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
    </div>
  )

  // OPS-1592: auth flow pages must work in the installed PWA shell too, ahead
  // of the auth gate. /auth/wasnt-me runs for signed-out and signed-in owners
  // alike; its reset_url handoff lands on /auth/confirm (verifyOtp, then onward
  // to /auth/reset-password), which establish a session mid-flow (same as App.jsx).
  const authPages = {
    '/auth/wasnt-me': WasntMe,
    '/auth/confirm': Confirm,
    '/auth/reset-password': ResetPassword,
  }
  const AuthPage = authPages[location.pathname]
  if (AuthPage) {
    return (
      <Suspense fallback={<LoadingSpinner />}>
        <AuthPage />
      </Suspense>
    )
  }

  if (!isAuthenticated) {
    return (
      <Suspense fallback={<LoadingSpinner />}>
        <Login onLogin={handleLogin} />
      </Suspense>
    )
  }

  return (
    <div className="min-h-screen bg-theme-primary flex flex-col">
      {/* Minimal PWA Header */}
      <header className="bg-theme-surface border-b border-theme px-4 py-3 flex items-center justify-between">
        <img 
          src="/assets/logos/logo-icon.svg" 
          alt="OpSyncPro" 
          className="h-8 w-auto"
        />
        <div className="flex items-center gap-2">
        <SupportHelp />
        <button
          onClick={handleLogout}
          className="p-2 text-gray-400 hover:text-white rounded-lg hover:bg-theme-hover"
          aria-label="Logout"
        >
          <LogOut className="w-5 h-5" />
        </button>
        </div>
      </header>

      {/* PWA Home - Simple Upload/Add Interface */}
      <main className="flex-1 overflow-hidden">
        <Suspense fallback={<LoadingSpinner />}>
          <PWAHome />
        </Suspense>
      </main>
    </div>
  )
}
